import * as React from 'react';
import type { CalendarEvent } from '../services/meetingsApi';
import { meetingsApi } from '../services/meetingsApi';

interface UseMeetingsState {
  events: CalendarEvent[];
  loading: boolean;
  error: string | null;
}

/**
 * Fetches upcoming calendar events for the workspace.
 * Re-fetches when `refreshKey` changes (e.g. after a sync).
 */
export function useMeetings(refreshKey?: number) {
  const [state, setState] = React.useState<UseMeetingsState>({
    events: [],
    loading: true,
    error: null,
  });

  const fetchEvents = React.useCallback(async () => {
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const data = await meetingsApi.listEvents({ limit: 100 });
      setState({ events: data.events, loading: false, error: null });
    } catch (err) {
      setState({
        events: [],
        loading: false,
        error: err instanceof Error ? err.message : 'Failed to load meetings',
      });
    }
  }, []);

  React.useEffect(() => {
    void fetchEvents();
  }, [fetchEvents, refreshKey]);

  return { ...state, refetch: fetchEvents };
}
